import { HOUSE_KEEPING_ROOT_ENDPOINT } from "./RootEndpoint";

export const HOUSE_KEEPING_GET_ALL = `${HOUSE_KEEPING_ROOT_ENDPOINT}`;
